module.exports = __webpack_public_path__ + "static/media/rund_um_geburt.c6365d73.jpg";